export default __webpack_public_path__ + "static/GSPANN-Logo-118e08f639b657b898557aacd9e34333.svg";